/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

export default $ => css(
  $.userSelects.map((value) => `
    .user-select-${value} { 
      user-select: ${value} !important; 
    }
  `)
);